<script setup lang="ts">
import { Popover, Tooltip, useScreenSize } from "@soft-db/ui";

defineSlots<{
	default(): void;
	tooltip(): void;
}>();

const { mdOrLower } = useScreenSize();
</script>

<template>
	<Popover v-if="mdOrLower">
		<template #trigger>
			<slot name="default" />
		</template>
		<div class="p-2">
			<slot name="tooltip" />
		</div>
	</Popover>
	<Tooltip v-else>
		<template #default>
			<slot name="default" />
		</template>
		<template #tooltip>
			<slot name="tooltip" />
		</template>
	</Tooltip>
</template>
